import React, { useEffect, useState } from "react";
import styles from "./AddBankModal.module.scss";
import {
  Box,
  Button,
  Checkbox,
  Fade,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputAdornment,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Formik, Form, useFormikContext, Field } from "formik";
import * as Yup from "yup";
import Close from "@mui/icons-material/Close";
import BankSnackBar from "../../../Components/SnackBars/BankSnackBar";
import {
  PrimaryBankRequestBankUpdateAPICall,
  ReSendOtpBankUpdateAPICall,
  SecondaryBankRequestBankUpdateAPICall,
  SendOtpBankUpdateAPICall,
} from "../BankUpdateAPICalls";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import proofEmpty from "../../../Components/assets/Images/proofemptycircle.svg";
import proofDone from "../../../Components/assets/Images/prooftickedcircle.svg";
import otpIcon from "../../../Components/assets/Images/otpIcon.svg";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import { SaveIpAddressAPICall } from "../../../shared/APICalls";

const schema = Yup.object().shape({
  bankAccountNumber: Yup.string()
    .required("Account Number is Required")
    .min(6, "Bank account number should be minimum 6 characters")
    .max(18, "Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .transform((value: any) => value && value.toUpperCase()),

  ConfirmBankAccountNumber: Yup.string()
    .required("Confirm Account Number is Required")
    .min(6, "Confirm Bank account number should be minimum 6 characters")
    .max(18, "Confirm Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .transform((value: any) => value && value.toUpperCase())
    .test(
      "match",
      "Account Number and Confirm Account Number should match",
      function (value) {
        return value === this.parent.bankAccountNumber;
      },
    ),

  ifscNumber: Yup.string()
    .required("IFSC is Required")
    .max(11, "Ifsc number should be maximum 11 characters")
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid IFSC")
    .transform((value: any) => value && value.toUpperCase()),
  // setprimary: Yup.boolean(),
  condition: Yup.boolean().oneOf([true], "Accept the condition"),
});

const mappingValues: any = {
  email: "Email",
  mobile: "Mobile",
};
function AddBankModal({
  showModal,
  handleCloseModifyModal,
  resumeBankDetails,
  optionSelected,
  bankDetailsFetched,
}) {
  const navigate = useNavigate();
  const reqId: any = sessionStorage.getItem("reqId");
  const [sendotpLoading, setsendotpLoading] = useState(false);
  const [submitLoading, setsubmitLoading] = useState(false);
  const [providerType, setProviderType] = useState("");
  const [micrNumber, setMicrNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ifscData, setIFSCData] = useState<any>({
    Bank: "",
    Address: "",
  });
  const [fetchedbankDetails, setfetchedbankDetails] = useState({
    bankAddress: "",
    bankName: "",
    branchName: "",
  });
  const [finalValues, setFinalValues] = useState({
    bankAccountNumber: "",
    ConfirmBankAccountNumber: "",
    ifscNumber: "",

    condition: true,
  });
  const [otp, setOtp] = useState("");

  const [displayOtpSection, setDisplayOtpSection] = useState(false);
  const [otpResponseData, setOtpResponseData] = useState({
    request_id: "",
    mobile_number: "",
    email: "",
  });
  const [successmessage, setsuccessmessage] = useState("");
  const [setasType, setSetasType] = useState("setprimary");
  const [countdown, setCountdown] = useState<any>(30);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timerId, setTimerId] = useState<any>(null);

  useEffect(() => {
    if (resumeBankDetails && resumeBankDetails?.ifsc !== "") {
      handleChangeField("ifscNumber", resumeBankDetails.ifsc);
    }
  }, [resumeBankDetails]);
  useEffect(() => {
    if (
      bankDetailsFetched?.payerVpa !== "" &&
      bankDetailsFetched?.bankAccountIfsc !== "" &&
      !resumeBankDetails
    ) {
      handleChangeField("ifscNumber", bankDetailsFetched?.bankAccountIfsc);
    }
  }, [bankDetailsFetched]);

  useEffect(() => {
    setIsButtonDisabled(true);
    setCountdown(30);
  }, []);

  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  useEffect(() => {
    if (otp?.length === 6) {
      secondaryBankRequest();
    }
  }, [otp]);

  const handleChangeField = (
    name: string,
    value: any,
    callBack?: any,

    values?: any,
  ) => {
    const ifscCode = value.toUpperCase();
    //  console.log(ifscCode);
    if (callBack) {
      callBack(name, ifscCode);
    }

    if (ifscCode.length === 11) {
      fetch(`https://ifsc.razorpay.com/${ifscCode}`)
        .then((response) => response.json())
        .then((data) => {
          // callBack("micrNumber", data.MICR === null ? "Not Found" : data.MICR);
          setMicrNumber(data.MICR === null ? "" : data.MICR);
          // console.log("data", data);
          if (data === "Not Found") {
            setErrorMessage("Please enter Valid IFSC");
            setIFSCData({
              Bank: "",
              Address: "",
            });
          }
          if (data !== "Not Found") {
            setfetchedbankDetails({
              bankAddress: data.ADDRESS,
              bankName: data.BANK,
              branchName: data.BRANCH,
            });
            setIFSCData({
              Bank: data.BANK,
              Address: data.BRANCH,
            });
          }
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        })
        .catch((error) => {
          // console.log(error);
        });
    }

    if (ifscCode.length < 11) {
      setIFSCData({
        Bank: "",
        Address: "",
      });
    }
  };
  const secondaryBankRequest = () => {
    let obj: any = {
      bank_details: {
        ifsc: finalValues.ifscNumber,
        micr: micrNumber,
        account_no: finalValues.bankAccountNumber,
        address: fetchedbankDetails.bankAddress,
        bank_name: fetchedbankDetails.bankName,
        branch_name: fetchedbankDetails.branchName,
        upi:
          bankDetailsFetched?.payerVpa !== ""
            ? bankDetailsFetched?.payerVpa
            : "",
      },
      request_id: otpResponseData.request_id,
      otp_type: providerType,
      // mobile: otpResponseData.mobile_number,
      otp: otp,
      make_bank_as_primary: setasType === "setprimary" ? true : false,
      bank_request_type: "Secondary Bank Modification",
    };

    setsubmitLoading(true);
    SecondaryBankRequestBankUpdateAPICall(obj)
      .then((response: any) => {
        setsubmitLoading(false);
        if (response.data?.data?.request_id) {
          sessionStorage.setItem("reqId", response.data.data.request_id);
        }

        navigate("/bankupdate/completed");

        //  console.log("submitResponse", response.data.data);
      })
      .catch((error: any) => {
        setsubmitLoading(false);
        //  console.log("error", error.response.data.error.message);
        if (error?.response?.data?.error?.message === "Bank already exists.") {
          setTimeout(() => {
            handleCloseModifyModal();
          }, 3000);
        }
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  const PrimaryBankRequest = (valuesPrimary: any) => {
    let obj: any = {
      bank_details: {
        ifsc: valuesPrimary.ifscNumber,
        micr: micrNumber,
        account_no: valuesPrimary.bankAccountNumber,
        address: fetchedbankDetails.bankAddress,
        bank_name: fetchedbankDetails.bankName,
        branch_name: fetchedbankDetails.branchName,
        upi:
          bankDetailsFetched?.payerVpa !== ""
            ? bankDetailsFetched?.payerVpa
            : "",
      },
      request_id: reqId ? reqId : null,
      bank_request_type: "Primary Bank Modification",
      make_bank_as_primary: true,
    };

    setsendotpLoading(true);
    PrimaryBankRequestBankUpdateAPICall(obj)
      .then((response: any) => {
        //  console.log("responsePrimary", response.data.data);
        setsendotpLoading(false);
        if (response.data?.data?.request_id) {
          sessionStorage.setItem("reqId", response.data.data.request_id);
          navigate("/bankupdate/esign");
        }
      })
      .catch((error: any) => {
        setsendotpLoading(false);
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  const handleOtp = (newValue: any) => {
    setOtp(newValue);
  };

  const SaveIpAddress = () => {
    let obj: any = {
      request_id: sessionStorage.getItem("reqId"),
      update_component: "bank_update",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("latitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {})
      .catch((error: any) => {});
  };

  const sendOtp = (values: any) => {
    let obj: any = {
      otp_type: providerType,
      bank_details: {
        ifsc: values.ifscNumber,
        micr: micrNumber,
        account_no: values.bankAccountNumber,
        address: fetchedbankDetails.bankAddress,
        bank_name: fetchedbankDetails.bankName,
        branch_name: fetchedbankDetails.branchName,
        upi:
          bankDetailsFetched?.payerVpa !== ""
            ? bankDetailsFetched?.payerVpa
            : "",
      },
      request_id: reqId ? reqId : null,
    };
    setsendotpLoading(true);
    SendOtpBankUpdateAPICall(obj)
      .then((response: any) => {
        setsendotpLoading(false);
        setIsButtonDisabled(true);
        setCountdown(30);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
        setOtpResponseData(response.data.data);

        sessionStorage.setItem("reqId", response.data.data.request_id);
        // console.log("response", response.data.data);
        setDisplayOtpSection(true);
        setsuccessmessage(response.data.message);
        SaveIpAddress();
        setTimeout(() => {
          setsuccessmessage("");
        }, 5000);
      })
      .catch((error: any) => {
        setsendotpLoading(false);
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  const handleResendOTP = (resendValues: any) => {
    let obj: any = {
      request_id: sessionStorage.getItem("reqId"),
      otp_type: providerType,
    };

    ReSendOtpBankUpdateAPICall(obj)
      .then((response: any) => {
        setIsButtonDisabled(true);
        setCountdown(30);
        if (timerId === null) {
          let interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTimerId(interval);
        }
        setsuccessmessage(response.data.message);
        setTimeout(() => {
          setsuccessmessage("");
        }, 5000);
      })
      .catch((error: any) => {
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  const handleKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValidKey = /^\d+$/.test(keyValue);

    if (!isValidKey) {
      event.preventDefault();
    }
  };

  function validateOTP(value: any) {
    let error: any;
    if (!value) {
      error = "OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  const InitialValues: any = {
    customerNameAsperBank:
      bankDetailsFetched?.bankAccountName !== ""
        ? bankDetailsFetched?.bankAccountName
        : resumeBankDetails
          ? resumeBankDetails.customer_name_in_bank
          : "",
    bankAccountNumber:
      bankDetailsFetched?.bankAccountNumber !== ""
        ? bankDetailsFetched?.bankAccountNumber
        : resumeBankDetails
          ? resumeBankDetails.account_no
          : "",
    ConfirmBankAccountNumber:
      bankDetailsFetched?.bankAccountNumber !== ""
        ? bankDetailsFetched?.bankAccountNumber
        : resumeBankDetails
          ? resumeBankDetails.account_no
          : "",
    ifscNumber:
      bankDetailsFetched?.bankAccountIfsc !== ""
        ? bankDetailsFetched?.bankAccountIfsc
        : resumeBankDetails
          ? resumeBankDetails.ifsc
          : "",

    condition: false,
  };

  // console.log("errorMessage", errorMessage);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showModal}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={showModal}>
        <Box className={styles.boxModalWrapper}>
          <SnackBar message={errorMessage} />
          <SucessSnackBar message={successmessage} />
          <Formik
            validationSchema={schema}
            initialValues={InitialValues}
            onSubmit={(values: any) => {
              setFinalValues(values);
              if (setasType === "setprimary") {
                PrimaryBankRequest(values);
              } else {
                sendOtp(values);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,

              setFieldValue,
            }) => {
              //  console.log("values", values);
              return (
                <form
                  noValidate
                  onSubmit={handleSubmit}
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                  style={{ width: "100%", height: "100%" }}
                >
                  <div className={styles.titleContainer}>
                    {" "}
                    <IconButton
                      onClick={() => {
                        setDisplayOtpSection(false);
                        handleCloseModifyModal();
                      }}
                    >
                      <ArrowBackIosIcon
                        style={{ color: "#1A1A1A", fontSize: "16px" }}
                      />
                    </IconButton>
                    Add Bank Account{" "}
                  </div>
                  <div className={styles.contentWrapper}>
                    <div className={styles.noteSection}>
                      <p className={styles.note}>
                        Please map your own bank account to your trading
                        account. You cannot link a third party bank account to
                        your trading account. If modifying primary bank account,
                        post successful verification, your existing primary bank
                        will be unmapped. Charge of ₹25 + 18% GST will be levied
                        for account modification.
                      </p>
                    </div>
                    {optionSelected === 1 ? (
                      <>
                        <div className={styles.textFeildSectionUPI}>
                          <div className={styles.textFeild}>
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              label="UPI ID"
                              variant="outlined"
                              // type="password"
                              value={bankDetailsFetched?.payerVpa}
                              disabled
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "var(--text-primary)",
                                    fontWeight: 500,
                                  },
                                  color: "var(--text-secondary)",
                                  fontSize: "14px",
                                },
                                maxLength: 18,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  // height: "55px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "var(--text-secondary)",
                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--text-primary)",
                                  },
                                },
                              }}
                            />
                          </div>
                          <div className={styles.textFeild}>
                            <TextField
                              fullWidth
                              disabled
                              id="outlined-basic"
                              label="Bank Account No"
                              variant="outlined"
                              value={bankDetailsFetched?.bankAccountNumber}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "var(--text-primary)",
                                    fontWeight: 500,
                                  },
                                  color: "var(--text-secondary)",
                                  fontSize: "14px",
                                },
                                maxLength: 18,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  // height: "55px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "var(--text-secondary)",

                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--text-primary)", // Label color when the field has a value
                                  },
                                },
                              }}
                            />
                          </div>
                          <div className={styles.textFeild}>
                            <TextField
                              fullWidth
                              disabled
                              id="outlined-basic"
                              label="Bank Name"
                              variant="outlined"
                              value={bankDetailsFetched?.ifscDetails?.name}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "var(--text-primary)",
                                    fontWeight: 500,
                                  },
                                  color: "var(--text-secondary)",
                                  fontSize: "14px",
                                },
                                maxLength: 11,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "var(--text-secondary)",

                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--text-primary)", // Label color when the field has a value
                                  },
                                },
                              }}
                            />
                            {/* <BankSnackBar message={ifscData} /> */}
                          </div>
                          <div className={styles.textFeild}>
                            <TextField
                              fullWidth
                              id="outlined-basic"
                              label="Name as per Bank Record"
                              variant="outlined"
                              // type="password"
                              value={bankDetailsFetched?.bankAccountName}
                              disabled
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "var(--text-primary)",
                                    fontWeight: 500,
                                  },
                                  color: "var(--text-secondary)",
                                  fontSize: "14px",
                                },
                                maxLength: 18,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  // height: "55px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "var(--text-secondary)",
                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--text-primary)",
                                  },
                                },
                              }}
                            />
                          </div>
                          <div className={styles.textFeild}>
                            <TextField
                              fullWidth
                              disabled
                              id="outlined-basic"
                              label="IFSC Code"
                              variant="outlined"
                              value={bankDetailsFetched?.bankAccountIfsc}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "var(--text-primary)",
                                    fontWeight: 500,
                                  },
                                  color: "var(--text-secondary)",
                                  fontSize: "14px",
                                },
                                maxLength: 18,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  // height: "55px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "var(--text-secondary)",

                                  fontWeight: 500,
                                  "&.MuiFormLabel-filled": {
                                    color: "var(--text-primary)", // Label color when the field has a value
                                  },
                                },
                              }}
                            />
                          </div>
                          <div
                            className={styles.textFeild}
                            style={{ visibility: "hidden" }}
                          >
                            <TextField
                              fullWidth
                              disabled
                              id="outlined-basic"
                              label="Bank Name"
                              variant="outlined"
                              value={bankDetailsFetched?.ifscDetails?.name}
                              inputProps={{
                                sx: {
                                  "&::label": {
                                    fill: "#111827",
                                    fontWeight: 400,
                                    fontFamily: "inherit !important",
                                  },
                                  color: "var(--Black-Black-500, #6B7280)",
                                  fontSize: "14px",
                                  fontFamily: "inherit !important",
                                },
                                maxLength: 18,

                                inputMode: "text",
                              }}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  color: "#6B7280",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontFamily: "inherit !important",
                                  "&.MuiFormLabel-filled": {
                                    color: "#111827",
                                    fontSize: "15px",
                                    fontWeight: 400,
                                    fontFamily: "inherit !important",
                                  },
                                },
                              }}
                            />
                            {/* <BankSnackBar message={ifscData} /> */}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className={styles.textFeildSection}>
                        <div className={styles.textFeild}>
                          <TextField
                            fullWidth
                            required
                            name="bankAccountNumber"
                            id="outlined-basic"
                            label="Account No"
                            variant="outlined"
                            type="password"
                            value={values.bankAccountNumber.toUpperCase()}
                            error={
                              touched.bankAccountNumber &&
                              Boolean(errors.bankAccountNumber)
                            }
                            helperText={
                              touched.bankAccountNumber &&
                              errors.bankAccountNumber?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 18,

                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontSize: "14px",
                                fontWeight: 400,
                                "&.MuiFormLabel-filled": {
                                  color: "#111827",
                                  fontSize: "15px",
                                  fontWeight: 400,
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={styles.textFeild}>
                          <TextField
                            fullWidth
                            required
                            id="outlined-basic"
                            label="Re Enter Account No"
                            variant="outlined"
                            name="ConfirmBankAccountNumber"
                            value={values.ConfirmBankAccountNumber.toUpperCase()}
                            error={
                              touched.ConfirmBankAccountNumber &&
                              Boolean(errors.ConfirmBankAccountNumber)
                            }
                            helperText={
                              touched.ConfirmBankAccountNumber &&
                              errors.ConfirmBankAccountNumber?.toString()
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 18,

                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontSize: "14px",
                                fontWeight: 400,
                                "&.MuiFormLabel-filled": {
                                  color: "#111827", // Label color when the field has a value
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                        </div>
                        <div className={styles.textFeild}>
                          <TextField
                            fullWidth
                            required
                            name="ifscNumber"
                            id="outlined-basic"
                            label="IFSC Code"
                            variant="outlined"
                            value={values.ifscNumber.toUpperCase()}
                            error={
                              touched.ifscNumber && Boolean(errors.ifscNumber)
                            }
                            helperText={
                              touched.ifscNumber &&
                              errors.ifscNumber?.toString()
                            }
                            onChange={(event) => {
                              handleChangeField(
                                "ifscNumber",
                                event.target.value,
                                setFieldValue,

                                values,
                              );
                            }}
                            onBlur={handleBlur}
                            inputProps={{
                              sx: {
                                "&::label": {
                                  fill: "#111827",
                                  fontWeight: 400,
                                },
                                color: "var(--Black-Black-500, #6B7280)",
                                fontSize: "14px",
                              },
                              maxLength: 11,

                              inputMode: "text",
                            }}
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                color: "#6B7280",
                                fontSize: "14px",
                                fontWeight: 400,
                                "&.MuiFormLabel-filled": {
                                  color: "#111827", // Label color when the field has a value
                                  fontSize: "15px",
                                },
                              },
                            }}
                          />
                          <BankSnackBar message={ifscData} />
                        </div>
                      </div>
                    )}
                    <div className={styles.checkBoxSection}>
                      <div
                        className={styles.checkBoxDiv}
                        style={{ display: "flex" }}
                      >
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            onChange={(event: any) => {
                              setSetasType(event.target.value);
                            }}
                            value={setasType}
                          >
                            <FormControlLabel
                              value="setprimary"
                              control={
                                <Radio
                                  sx={{ width: "25px", height: "25px" }}
                                  icon={
                                    <img
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      src={proofEmpty}
                                    />
                                  }
                                  checkedIcon={
                                    <img
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      src={proofDone}
                                    />
                                  }
                                />
                              }
                              label={<span>Set As Primary</span>}
                            />
                            <FormControlLabel
                              value="setsecondary"
                              control={
                                <Radio
                                  sx={{ width: "25px", height: "25px" }}
                                  icon={
                                    <img
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      src={proofEmpty}
                                    />
                                  }
                                  checkedIcon={
                                    <img
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                      }}
                                      src={proofDone}
                                    />
                                  }
                                />
                              }
                              label={<span>Set As Secondary</span>}
                            />
                          </RadioGroup>
                        </FormControl>
                        {/* <FormGroup sx={{ display: "flex" }}>
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="setprimary"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#000",
                                  },
                                }}
                                checked={values.setprimary}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  setProviderType("");
                                  setFieldValue("setprimary", checked);
                                }}
                                onBlur={handleBlur}
                              />
                            }
                            label={
                              <span className={styles.label}>
                                Set As Primary.
                              </span>
                            }
                            disabled={displayOtpSection}
                          />
                        </FormGroup> */}
                      </div>
                      <div className={styles.checkBoxDiv}>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                name="condition"
                                sx={{
                                  padding: "0px",
                                  "&.Mui-checked": {
                                    color: "#000",
                                  },
                                }}
                                checked={values.condition}
                                onChange={(event) => {
                                  const { checked } = event.target;
                                  setFieldValue("condition", checked);
                                }}
                                onBlur={handleBlur}
                              />
                            }
                            label={
                              <span className={styles.label}>
                                I/We hereby declare that the above information
                                provided by me, is true and to the best of my
                                knowledge. I/We undertake to inform Firstock
                                Broking Ltd. of any discrepancies, changes, or
                                incorrect information that I become aware of,
                                immediately. I/We understand that in case any
                                information provided above is incorrect or
                                misleading, I/We would be held liable for all
                                such consequences/actions taken with respect to
                                the above information. This change will affect
                                the Trading and Demat account that I hold with
                                Firstock Broking Ltd.
                              </span>
                            }
                          />
                        </FormGroup>
                        <FormHelperText style={{ color: "#ef5350" }}>
                          {touched.condition && errors.condition?.toString()}
                        </FormHelperText>
                      </div>
                    </div>

                    {setasType !== "setprimary" && (
                      <div className={styles.otpSection}>
                        {!displayOtpSection && (
                          <div className={styles.radioSection}>
                            <p className={styles.receiveOTPtext}>
                              Receive OTP On
                            </p>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={(event: any) => {
                                  setProviderType(event.target.value);
                                }}
                              >
                                <FormControlLabel
                                  value="email"
                                  control={
                                    <Radio
                                      sx={{ width: "25px", height: "25px" }}
                                      icon={
                                        <img
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                          src={proofEmpty}
                                        />
                                      }
                                      checkedIcon={
                                        <img
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                          src={proofDone}
                                        />
                                      }
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color:
                                          providerType === "email"
                                            ? ""
                                            : "#999",
                                      }}
                                    >
                                      Email
                                    </span>
                                  }
                                />
                                <FormControlLabel
                                  value="mobile"
                                  control={
                                    <Radio
                                      sx={{ width: "25px", height: "25px" }}
                                      icon={
                                        <img
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                          src={proofEmpty}
                                        />
                                      }
                                      checkedIcon={
                                        <img
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                          src={proofDone}
                                        />
                                      }
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color:
                                          providerType === "mobile"
                                            ? ""
                                            : "#999",
                                      }}
                                    >
                                      Mobile
                                    </span>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        )}
                        {displayOtpSection && (
                          <div className={styles.enterOTP}>
                            <p className={styles.enterOTPText}>Enter OTP</p>
                            <p className={styles.enterOTPDesc}>
                              OTP Sent to {mappingValues[providerType]}{" "}
                              {otpResponseData[mappingValues[providerType]]}
                              {isButtonDisabled ? (
                                <span
                                  className={styles.resendOTPText}
                                  // onClick={handleResendOTP}
                                  style={{ color: "grey" }}
                                >
                                  Resend OTP in {countdown}s
                                </span>
                              ) : (
                                <span
                                  className={styles.resendOTPText}
                                  onClick={() => {
                                    handleResendOTP(values);
                                  }}
                                >
                                  Resend OTP
                                </span>
                              )}
                            </p>
                            <div className={styles.mobileDisplayOTP}>
                              <Field
                                name="mobileotp"
                                validate={validateOTP}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    placeholder="••••••"
                                    type="numeric"
                                    className={styles.textfield}
                                    variant="outlined"
                                    value={values.mobileotp}
                                    onChange={(event) => {
                                      const updatedValue = event.target.value;
                                      setOtp(updatedValue);
                                    }}
                                    onKeyPress={(event) => {
                                      const keyCode =
                                        event.keyCode || event.which;
                                      const keyValue =
                                        String.fromCharCode(keyCode);
                                      const isValidKey = /^\d+$/.test(keyValue);

                                      if (!isValidKey) {
                                        event.preventDefault();
                                      }
                                    }}
                                    inputProps={{
                                      sx: {
                                        "&::placeholder": {
                                          paddingLeft: "-20px",
                                          fill: "var(--Black-Black-500, #6B7280)",
                                          fontWeight: 600,
                                          fontSize: "2.5rem",
                                          background: "transparent",
                                          height: { xs: "36px", sm: "36px" },
                                          letterSpacing: "18px",
                                        },
                                        // borderLeft: "1px solid #E5E7EB",
                                        // height: "30px",
                                        paddingLeft: "-20px",
                                        fontWeight: 500,
                                        letterSpacing: "23px",
                                        background: "transparent",
                                      },
                                      maxLength: 6,
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment
                                          position="start"
                                          style={{
                                            // borderRight: "1px solid #E5E7EB",
                                            // height: "22px",
                                            paddingRight: "10px",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <img src={otpIcon} />
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className={styles.buttonStack}>
                    <Button
                      variant="outlined"
                      style={{width:"101px"}}
                      onClick={() => {
                        setDisplayOtpSection(false);
                        handleCloseModifyModal();
                      }}
                    >
                      Cancel
                    </Button>
                    {displayOtpSection ? (
                      <LoadingButton
                        variant="contained"
                        id="linkUsingIFSCContinueButton"
                        className={styles.approveButton}
                        sx={{
                          fontSize: "12px",
                          height: "40px",
                          padding: "3px 40px",
                        }}
                        disabled={otp.length !== 6}
                        loading={submitLoading}
                        onClick={secondaryBankRequest}
                      >
                        Submit
                      </LoadingButton>
                    ) : (
                      <LoadingButton
                        loading={sendotpLoading}
                        variant="contained"
                        type="submit"
                        id="linkUsingIFSCContinueButton"
                        className={styles.approveButton}
                        disabled={
                          providerType === "" && setasType !== "setprimary"
                        }
                        sx={{
                          fontSize: "12px",
                          height: "40px",
                          padding: "3px 40px",
                        }}
                      >
                        {setasType === "setprimary" ? "Submit" : "Send OTP"}
                      </LoadingButton>
                    )}
                  </div>
                </form>
              );
            }}
          </Formik>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddBankModal;
